import { createSlice } from "@reduxjs/toolkit";

const usersSlice = createSlice({
  name: "users",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    fetchUsersStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchUsersSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fecthUsersFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchUsersStart, fetchUsersSuccess, fecthUsersFailure } =
  usersSlice.actions;
export default usersSlice.reducer;
